import React, { Component } from 'react';
import { CardTitle, CardSubtitle, FormGroup, Input, Label, Row } from 'reactstrap';

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit } from '../../routes/routes'

/* Object Json */
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';

import './style.css';
import { isEmpty } from 'iotera-base/object';
import { getToken } from '../../auth/app';
import { SubViewHeader } from '../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import Result from 'iotera-base/result';
import { copyTextToClipboard } from '../../lib/components/function';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const REFRESH_TOKEN = "REFRESH_TOKEN";
const WKEY = 'API';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class RefreshToken extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      token: '',
      isDisabled: true
    };
    this.handleToken = this.handleToken.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall({
      wparam: { ...domainIsTenant, path: '/service/web/application/account/open/token/get' },
      wcallback: {
        started: function (id) {
          // TODO Loading
        },
        finished: function (id, result) {
          // TODO Loading
        }
      }
    });
    _props.wSetConfig({
      single_config: {
        [REFRESH_TOKEN]: {
          wparam: {
            ...domainIsTenant, method: "POST", path: "/service/web/application/account/open/token/gen"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  const refreshToken = safeDeepGetWithType(result, ['body', 'refresh_token'], '');
                  if (refreshToken !== '') {
                    copyTextToClipboard(refreshToken)
                    _props.showSingleNotification({ message: 'Refresh token telah di-copy ke clipboard.', level: 'info' });
                  }
                }
              }
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  handleToken(event, emptyToken) {
    event.preventDefault();
    const _this = this
    const _props = _this.props
    if (!emptyToken) {
      ioteraConfirmAlert(
        null,
        'Apakah anda yakin ingin me-regenerate token ini? Seluruh akses yang memakai token sebelumnya akan di-non-aktifkan.',
        null,
        () => _props.wSingleRequestCall({
          id: REFRESH_TOKEN,
          body: {}
        }),
        null,
        null
      )
    } else {
      _props.wSingleRequestCall({
        id: REFRESH_TOKEN,
        body: {}
      })
    }
  }

  render() {
    const _this = this
    const _props = _this.props
    const domainIsTenant = dit(_props);
    const domain = safeDeepGet(domainIsTenant, ['domain'])
    const userId = getToken(domain);
    const id = safeDeepGet(userId, ['id'])
    let token = safeDeepGetWithType(_props, ['refresh_token']);
    let empty = false;
    let tokenTitle = "Generate"
    if (isEmpty(token)) {
      token = safeDeepGetWithType(_props, ['init_token']);
      tokenTitle = "Regenerate"
      if (isEmpty(token)) {
        tokenTitle = "Generate"
        token = '';
        empty = true;
      }
    } else {
      tokenTitle = "Regenerate"
    }
    return (
      <div className="view">
        <SubViewHeader title='Refresh Token' subTitle='Formulir Refresh token untuk pengguna' />
        <div className="view-content-dashboard">
          <form>
            <Row className="centeringItem" style={{ height: 350 }}>
              <div className="col-md-10" id="divMy">
                <CardTitle className="text-capitalize h4 text-center">Refresh Token Pengguna</CardTitle>
                <CardSubtitle className="text-center" style={{ fontStyle: 'italic' }}>
                  ( Account ID: <span style={{ color: '#4D2C91', fontWeight: 'bold' }}>{id}</span> )
                </CardSubtitle>
                <Label className="text-center" style={{ width: '100%', marginBottom: 20 }}>
                  Klik tombol di bawah untuk me-refresh token dari pengguna
                </Label>
                <FormGroup row>
                  <div className="col-md-4 button-right" style={{ marginBottom: 10 }}>
                    <Button variant="outlined" size="large" color="primary" onClick={event => _this.handleToken(event, empty)}
                      style={{ marginLeft: 10, minWidth: '0%' }}>{tokenTitle}</Button>
                  </div>
                  <div className="col-md-8">
                    <Input type="text" value={token} name="token" id="provisioningToken" style={{ height: 40 }} readOnly />
                  </div>
                </FormGroup>
                <div style={{ textAlign: 'center', marginTop: 20 }}>
                  <Button style={{ minWidth: '40%', display: 'none' }} color="info" onClick={_this.myFunction} outline>
                    Lanjutkan Konfigurasi Sebelumnya
                  </Button>
                </div>
              </div>
            </Row>
            <hr />
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    init_token: wSelector.getSoleInitMappedRPayload(state, 'refresh_token'),
    refresh_token: wSelector.getMappedRPayload(state, REFRESH_TOKEN, 'refresh_token')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(RefreshToken);